import { useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { adressenAPI } from '@/lib/api';
import { useOrtAusPlz, OrtVorschlaege } from '@/lib/stammdaten';

/* Adresse eintragen (23.10.2026): Straße, PLZ, Ort — der Ort kommt aus der PLZ (Stammdaten), eine Handeingabe bleibt.
   Gespeichert wird über PUT /api/adressen/{lead}: Lead und laufende Verträge, das Vertrags-PDF vermerkt die Änderung. */
export default function AdresseFormular({ leadId, start, onGespeichert, onAbbrechen, kompakt = false, tid = 'adresse' }) {
  const [f, setF] = useState({ strasse: start?.strasse || '', plz: start?.plz || '', ort: start?.ort || '' });
  const [busy, setBusy] = useState(false);
  const orte = useOrtAusPlz(f.plz, f.ort, (ort) => setF((x) => ({ ...x, ort })));
  const setzen = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const speichern = async (e) => {
    e?.preventDefault();
    setBusy(true);
    try {
      const r = await adressenAPI.setzen(leadId, f);
      const n = r.data.vertraege?.length || 0;
      toast.success(`Adresse gespeichert${n ? ` · ${n === 1 ? '1 Vertrag' : `${n} Verträge`} aktualisiert` : ''}`);
      onGespeichert?.(r.data);
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Speichern fehlgeschlagen');
    }
    setBusy(false);
  };
  return (
    <form onSubmit={speichern} className={kompakt ? 'flex flex-wrap items-start gap-2' : 'space-y-2'} data-testid={`${tid}-form`}>
      <Input value={f.strasse} onChange={setzen('strasse')} placeholder="Straße und Hausnummer" autoComplete="street-address"
        className={kompakt ? 'h-8 text-xs flex-1 min-w-[10rem]' : 'h-9'} data-testid={`${tid}-strasse`} />
      <div className={kompakt ? 'flex gap-2' : 'grid grid-cols-[6rem_1fr] gap-2'}>
        <Input value={f.plz} onChange={setzen('plz')} placeholder="PLZ" inputMode="numeric" maxLength={5} autoComplete="postal-code"
          className={kompakt ? 'h-8 text-xs w-20' : 'h-9'} data-testid={`${tid}-plz`} />
        <div className={kompakt ? 'min-w-[8rem]' : ''}>
          <Input value={f.ort} onChange={setzen('ort')} placeholder="Ort" autoComplete="address-level2"
            className={kompakt ? 'h-8 text-xs' : 'h-9'} data-testid={`${tid}-ort`} />
          <OrtVorschlaege orte={orte} aktuell={f.ort} wahl={(ort) => setF((x) => ({ ...x, ort }))} />
        </div>
      </div>
      <div className="flex gap-2">
        <Button type="submit" size="sm" disabled={busy} className={kompakt ? 'h-8' : ''} data-testid={`${tid}-speichern`}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Speichern'}
        </Button>
        {onAbbrechen && <Button type="button" size="sm" variant="outline" onClick={onAbbrechen} disabled={busy} className={kompakt ? 'h-8' : ''}>Abbrechen</Button>}
      </div>
    </form>
  );
}
